import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { AdditionalFilter } from '@ddv/models';
import { deepClone } from '@ddv/utils';
import { FilterDropdownAnchorComponent } from '@hs/ui-core-dropdowns';
import { ModalDirective, ModalOptions } from '@hs/ui-core-layout';

import { DashboardFiltersModalComponent } from './dashboard-filters-modal/dashboard-filters-modal.component';

@Component({
    selector: 'ddv-additional-filters-dropdown',
    templateUrl: './additional-filters-dropdown.component.html',
    styleUrls: ['./additional-filters-dropdown.component.scss'],
    imports: [
        ModalDirective,
        DashboardFiltersModalComponent,
        FilterDropdownAnchorComponent,
    ],
})
export class AdditionalFiltersDropdownComponent implements AfterViewInit, OnChanges {
    @Input() widgetId = 0;
    @Input() filters: AdditionalFilter[] = [];

    @Output() filtersApplied = new EventEmitter<AdditionalFilter[]>();

    protected anchorText = '0 selected';
    protected showModal = false;
    protected modalOptions: ModalOptions = {};
    protected filtersCopy: AdditionalFilter[] = [];

    @ViewChild('anchor', { static: false, read: ElementRef }) private readonly anchor: ElementRef<HTMLElement> | undefined;

    ngAfterViewInit(): void {
        this.modalOptions = {
            anchorToElement: this.anchor?.nativeElement,
            position: 'bottom-right',
            customWidth: 60,
        };
    }

    ngOnChanges(): void {
        this.anchorText = anchorText(this.filters);
        this.filtersCopy = deepClone(this.filters) ?? [];
    }

    protected onFiltersApplied(updatedFilters: AdditionalFilter[]): void {
        this.showModal = false;
        this.anchorText = anchorText(updatedFilters);
        this.filtersApplied.emit(updatedFilters);
    }
}

function anchorText(filters: AdditionalFilter[]): string {
    return `${filters.length} selected`;
}
